(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9742],{

/***/ 27627:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgot-password",
      function () {
        return __webpack_require__(96334);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ CustomTextArea; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _atoms_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67191);
/* harmony import */ var _atoms_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_atoms_module_scss__WEBPACK_IMPORTED_MODULE_3__);





var CustomTextArea = function(_param) {
    var inpValue = _param.inpValue, label = _param.label, value = _param.value, className = _param.className, handleChange = _param.handleChange, _withStar = _param.withStar, withStar = _withStar === void 0 ? false : _withStar, _custom = _param.custom, custom = _custom === void 0 ? false : _custom, required = _param.required, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "inpValue",
        "label",
        "value",
        "className",
        "handleChange",
        "withStar",
        "custom",
        "required"
    ]);
    var LabelName = custom ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        children: value
    }) : value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_atoms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().custom_textArea_checkout),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                className: (_atoms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().custom_textarea),
                id: props.name,
                placeholder: " ",
                required: !!required,
                autoComplete: "off",
                value: inpValue,
                onChange: handleChange
            }, props)),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: (_atoms_module_scss__WEBPACK_IMPORTED_MODULE_3___default().custom_input_label),
                htmlFor: props.name,
                children: [
                    LabelName,
                    withStar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_atoms_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["red-fms"]),
                        children: " *"
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 78624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ CustomTextField; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _services_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75681);
/* harmony import */ var _atoms_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67191);
/* harmony import */ var _atoms_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_atoms_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var CustomTextField = function(_param) {
    var _type = _param.type, type = _type === void 0 ? "" : _type, _inpValue = _param.inpValue, inpValue = _inpValue === void 0 ? "" : _inpValue, _label = _param.label, label = _label === void 0 ? "" : _label, _value = _param.value, value = _value === void 0 ? "" : _value, _className = _param.className, className = _className === void 0 ? "" : _className, handleChange = _param.handleChange, _withStar = _param.withStar, withStar = _withStar === void 0 ? false : _withStar, _defaultValue = _param.defaultValue, defaultValue = _defaultValue === void 0 ? "" : _defaultValue, _isUsed = _param.isUsed, isUsed = _isUsed === void 0 ? "" : _isUsed, code = _param.code, required = _param.required, _pattern = _param.pattern, pattern = _pattern === void 0 ? "" : _pattern, _err = _param.err, err = _err === void 0 ? false : _err, _custom = _param.custom, custom = _custom === void 0 ? false : _custom, _id = _param.id, id = _id === void 0 ? "" : _id, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "type",
        "inpValue",
        "label",
        "value",
        "className",
        "handleChange",
        "withStar",
        "defaultValue",
        "isUsed",
        "code",
        "required",
        "pattern",
        "err",
        "custom",
        "id"
    ]);
    var newType = type ? type : "text";
    var customClassName = className ? className : "";
    var generatedId = id ? id : props.name + (0,_services_utils__WEBPACK_IMPORTED_MODULE_2__/* .idGen */ ["do"])();
    var newPattern = pattern ? pattern : "";
    var LabelName = custom ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
        children: value
    }) : value;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_atoms_module_scss__WEBPACK_IMPORTED_MODULE_4___default().custom_input_checkout), " ").concat(customClassName),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                className: "".concat((_atoms_module_scss__WEBPACK_IMPORTED_MODULE_4___default().custom_input_field), " ").concat(err && (_atoms_module_scss__WEBPACK_IMPORTED_MODULE_4___default().err_field)),
                id: generatedId,
                type: newType,
                placeholder: " ",
                autoComplete: "off",
                value: isUsed ? code : inpValue,
                onChange: handleChange,
                disabled: !!isUsed
            }, props), {
                required: !!required
            })),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("label", {
                className: (_atoms_module_scss__WEBPACK_IMPORTED_MODULE_4___default().custom_input_label),
                htmlFor: generatedId,
                children: [
                    LabelName,
                    withStar && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_atoms_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["red-fms"]),
                        children: " *"
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 69607:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AP": function() { return /* reexport */ CustomSelect; },
  "Ks": function() { return /* reexport */ CustomTextArea/* CustomTextArea */.K; },
  "yM": function() { return /* reexport */ CustomTextField/* CustomTextField */.y; }
});

// EXTERNAL MODULE: ./atoms/CustomTextField.tsx
var CustomTextField = __webpack_require__(78624);
// EXTERNAL MODULE: ./atoms/CustomTextArea.tsx
var CustomTextArea = __webpack_require__(77280);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./atoms/atoms.module.scss
var atoms_module = __webpack_require__(67191);
var atoms_module_default = /*#__PURE__*/__webpack_require__.n(atoms_module);
// EXTERNAL MODULE: ./svg/index.js
var svg = __webpack_require__(69587);
;// CONCATENATED MODULE: ./atoms/CustomSelect.tsx
/**
 *   was created by tigran at 05.10.23
 **/ 





var CustomSelect = function(param) {
    var onChange = param.onChange, defaultSelected = param.defaultSelected, selectList = param.selectList, _asterisk = param.asterisk, asterisk = _asterisk === void 0 ? false : _asterisk, messageId = param.messageId, name = param.name, printedFieldName = param.printedFieldName, translationsData = param.translationsData, _disabled = param.disabled, disabled = _disabled === void 0 ? true : _disabled, fullHeight = param.fullHeight, containerHeight = param.containerHeight;
    var defSelectedAttribute = defaultSelected ? {
        defaultValue: defaultSelected
    } : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (atoms_module_default()).select_wrapper,
        children: selectList && selectList.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (atoms_module_default()).select_label_title,
                    children: [
                        translationsData[messageId],
                        asterisk && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: (atoms_module_default()).select_asterisk,
                            children: " *"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: (atoms_module_default()).select_container,
                    style: containerHeight ? {
                        height: "".concat(containerHeight, "px")
                    } : {},
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("select", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            className: (atoms_module_default()).select_width,
                            name: name,
                            onChange: onChange,
                            style: fullHeight ? {
                                height: "100%"
                            } : {}
                        }, defSelectedAttribute), {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                    disabled: disabled,
                                    children: translationsData[messageId]
                                }),
                                selectList.map(function(option, index) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("option", {
                                        value: option[printedFieldName],
                                        children: option[printedFieldName]
                                    }, index);
                                })
                            ]
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (atoms_module_default()).caret_wrapper,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(svg/* ArrowRoundedDown12x7Svg */.bD, {})
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./atoms/index.ts





/***/ }),

/***/ 64465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69587);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(12820);
/* harmony import */ var _shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_shared_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4298);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_script__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _schemaorg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(91257);








var PageHeader = function(props) {
    var _breadcrumb = props.breadcrumb, breadcrumb = _breadcrumb === void 0 ? [] : _breadcrumb, dbName = props.dbName;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var schema = (0,_schemaorg__WEBPACK_IMPORTED_MODULE_6__/* .schemaPageHeader */ .ed)(dbName, router.asPath, breadcrumb);
    if (breadcrumb.length > 0) {
        var lastIndex = breadcrumb.length - 1;
        breadcrumb = breadcrumb.map(function(item, index) {
            var link;
            if (lastIndex === index) {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_script__WEBPACK_IMPORTED_MODULE_5___default()), {
                            id: schema.name,
                            type: "application/ld+json",
                            dangerouslySetInnerHTML: {
                                __html: JSON.stringify(schema)
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]), " ").concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item-active"])),
                            "aria-current": "page",
                            children: item.title
                        })
                    ]
                }, index);
            } else {
                link = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-item"]),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                            href: item.url,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                children: item.title
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_svg__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRoundedRight6x9Svg */ .EO, {
                            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["breadcrumb-arrow"])
                        })
                    ]
                }, index);
            }
            return link;
        });
        breadcrumb = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__breadcrumb"]),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                "aria-label": "breadcrumb",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                    className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default().breadcrumb),
                    children: breadcrumb
                })
            })
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header"]),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "".concat((_shared_module_scss__WEBPACK_IMPORTED_MODULE_7___default()["page-header__container"]), " container"),
            children: breadcrumb
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageHeader);


/***/ }),

/***/ 96334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ forgot_password; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./api/shop.ts + 1 modules
var shop = __webpack_require__(65564);
// EXTERNAL MODULE: ./atoms/index.ts + 1 modules
var atoms = __webpack_require__(69607);
// EXTERNAL MODULE: ./components/account/account.module.scss
var account_module = __webpack_require__(67707);
var account_module_default = /*#__PURE__*/__webpack_require__.n(account_module);
// EXTERNAL MODULE: ./services/utils.js
var utils = __webpack_require__(75681);
// EXTERNAL MODULE: ./components/shared/PageHeader.tsx
var PageHeader = __webpack_require__(64465);
;// CONCATENATED MODULE: ./components/account/AccountForgotPassword.tsx







var AccountForgotPassword = function(param) {
    var breadcrumb = param.breadcrumb, translationsData = param.translationsData, dbName = param.dbName;
    var ref = (0,react.useState)(), input = ref[0], setInput = ref[1];
    var ref1 = (0,react.useState)(""), errors = ref1[0], setErrors = ref1[1];
    var ref2 = (0,react.useState)({
        success: "",
        danger: ""
    }), note = ref2[0], setNote = ref2[1];
    var handleChange = function(e) {
        return setInput(e.target.value);
    };
    var sedForgot = function(event) {
        event.preventDefault();
        if (input) {
            shop["default"].getForgetPassword(input).then(function(res) {
                if (res === "Email has been sent successfully") {
                    setErrors("");
                    setNote({
                        success: res,
                        danger: ""
                    });
                } else {
                    setNote({
                        success: "",
                        danger: res
                    });
                }
            }).catch(function() {
                return setErrors("the_email_must_be_a_valid_email_address.");
            });
        } else setErrors("the_email_field_is_required");
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "page ".concat((account_module_default())["background-image"]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(PageHeader/* default */.Z, {
                dbName: dbName,
                breadcrumb: breadcrumb
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (account_module_default()).page__forgot_password,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (account_module_default())["card-wrapper"],
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (account_module_default()).card,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (account_module_default())["card-body"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        className: (account_module_default())["card-title"],
                                        children: translationsData.ForgotPassword
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: (account_module_default())["signUp-position-relative"],
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms/* CustomTextField */.yM, {
                                                        value: translationsData.Email,
                                                        type: "email",
                                                        name: "email",
                                                        inpValue: input,
                                                        handleChange: handleChange
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "alert alert-danger",
                                                        children: errors && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "alert-danger",
                                                            children: translationsData[(0,utils/* spaceToUpperCaseConvertor */.WD)(errors)]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                type: "submit",
                                                onClick: sedForgot,
                                                className: "btn btn-lg btn-orange ".concat((account_module_default())["login-button"], " ").concat((account_module_default()).sbm_button),
                                                children: translationsData.Send
                                            }),
                                            note.danger ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "alert",
                                                style: {
                                                    marginTop: "20px",
                                                    borderRadius: "4px",
                                                    background: "#ffb8b8",
                                                    color: "#473333"
                                                },
                                                children: translationsData[(0,utils/* spaceToUpperCaseConvertor */.WD)(errors)]
                                            }) : note.success && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "alert alert-success",
                                                style: {
                                                    marginTop: "20px",
                                                    borderRadius: "4px"
                                                },
                                                children: translationsData.EmailHasBeenSentSuccessfully
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var account_AccountForgotPassword = (AccountForgotPassword);

// EXTERNAL MODULE: ./helper.js
var helper = __webpack_require__(63385);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/ForCWV/Wrappers/MainLayout.tsx + 31 modules
var MainLayout = __webpack_require__(11416);
;// CONCATENATED MODULE: ./pages/forgot-password.tsx









var ForgotPassword = function(pageProps) {
    var dbName = pageProps.dbName, selectedLocale = pageProps.selectedLocale, translationsData = pageProps.translationsData, breadcrumb = pageProps.breadcrumb, defaultLangCode = pageProps.defaultLangCode, locales = pageProps.locales;
    var router = (0,next_router.useRouter)();
    var meta_title = translationsData.ForgotPassword;
    var meta_description = "Forgot password page";
    var meta_keywords = "";
    var meta_url = (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.locale !== "catchAll" && router.locale !== defaultLangCode ? "/" + selectedLocale : "").concat(router.asPath));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(MainLayout/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, pageProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                            children: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "keywords",
                            content: meta_keywords
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "generator",
                            content: "Zegashop.com"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            name: "twitter:title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:description",
                            content: meta_description
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:title",
                            content: meta_title
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:keywords",
                            content: meta_keywords
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:url",
                            content: meta_url
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                            property: "og:locale",
                            content: selectedLocale
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                            rel: "canonical",
                            href: meta_url
                        }),
                        (locales === null || locales === void 0 ? void 0 : locales.length) > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                    rel: "alternate",
                                    href: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.asPath)),
                                    hrefLang: "x-default"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                    rel: "alternate",
                                    href: (0,helper/* domainUrl */.HJ)("".concat(dbName).concat(router.asPath)),
                                    hrefLang: defaultLangCode
                                }),
                                locales.map(function(intl) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                                        rel: "alternate",
                                        href: (0,helper/* domainUrl */.HJ)("".concat(dbName, "/").concat(intl.code).concat(router.asPath)),
                                        hrefLang: intl.code
                                    });
                                })
                            ]
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(account_AccountForgotPassword, {
                    dbName: dbName,
                    breadcrumb: breadcrumb,
                    translationsData: translationsData
                })
            ]
        })
    }));
};
var __N_SSP = true;
/* harmony default export */ var forgot_password = (ForgotPassword);


/***/ }),

/***/ 67191:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"select_global":"atoms_select_global__9eedR","toasts-wrapper":"atoms_toasts-wrapper__f9E7x","toast":"atoms_toast__c1BL3","toast-in-right":"atoms_toast-in-right__oeYsw","toast__text":"atoms_toast__text__EPBnn","toast__close-btn":"atoms_toast__close-btn__dMM0t","custom_textArea_checkout":"atoms_custom_textArea_checkout__07AIE","custom_textarea":"atoms_custom_textarea__bxfYq","custom_input_label":"atoms_custom_input_label__dMW0i","custom_input_field":"atoms_custom_input_field__8JhNw","red-fms":"atoms_red-fms__gy8KO","custom_input_checkout":"atoms_custom_input_checkout__QDlqs","err_field":"atoms_err_field__aGr7k","signUp-position-relative":"atoms_signUp-position-relative__Q1wgP","form-group":"atoms_form-group__lbJzQ","input-paddings":"atoms_input-paddings__WnO_x","signUp-position-radio-flex":"atoms_signUp-position-radio-flex___S_MV","signUp-position-no-input":"atoms_signUp-position-no-input__7Zhfu","custom_multiselect":"atoms_custom_multiselect__xCPeT","open":"atoms_open__499_m","custom_select-button":"atoms_custom_select-button__R9Agp","custom_multiselect-arrow":"atoms_custom_multiselect-arrow__e_Dc6","custom_multiselect-drop_down":"atoms_custom_multiselect-drop_down__yTDyD","custom_multiselect-button":"atoms_custom_multiselect-button__xacoC","custom_multiselect-button_selected":"atoms_custom_multiselect-button_selected__lOZW7","selected_del_btn":"atoms_selected_del_btn__kgNNw","custom_multiselect-option":"atoms_custom_multiselect-option__TbKPh","selected_option":"atoms_selected_option__C10_7","signUp-position-yes-no":"atoms_signUp-position-yes-no__kakyJ","signUp-position-yes-input":"atoms_signUp-position-yes-input__wAo2f","drop_down":"atoms_drop_down__oFda3","drop_down_btn":"atoms_drop_down_btn__ZShbQ","drop_down_arrow":"atoms_drop_down_arrow__CX3gx","drop_down_opened":"atoms_drop_down_opened___THG_","drop_down_block":"atoms_drop_down_block__ZrZ9T","drop_down_option":"atoms_drop_down_option__KFMWc","select_wrapper":"atoms_select_wrapper__pzpP1","select_label_title":"atoms_select_label_title__FkHzd","select_asterisk":"atoms_select_asterisk__ycLWy","select_container":"atoms_select_container__xwpkP","select_width":"atoms_select_width__GyLl1","caret_wrapper":"atoms_caret_wrapper__GSM1Z"};

/***/ }),

/***/ 12820:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"line__active":"shared_line__active___ydao","under_line__active":"shared_under_line__active__TzH_Z","text-success":"shared_text-success__b_GSc","text-danger":"shared_text-danger__uaRO3","product__prices":"shared_product__prices__CVW7b","color-lightgray":"shared_color-lightgray__tr4MM","product-card__new-price":"shared_product-card__new-price__Uh_wK","product-card__new-price_old_value":"shared_product-card__new-price_old_value__lZEg1","product-card__old-price":"shared_product-card__old-price__qVzw5","test":"shared_test__XJFgh","slick-prevent-click":"shared_slick-prevent-click__46Rz_","product-gallery__carousel":"shared_product-gallery__carousel__rweRi","slick-list":"shared_slick-list__Qm8q0","slick-track":"shared_slick-track__e1on5","product__gallery":"shared_product__gallery__2Qcoo","product-gallery__featured":"shared_product-gallery__featured__7qvkg","product-image__body":"shared_product-image__body___pMPQ","product-image":"shared_product-image__RGE_Z","product-gallery__zoom":"shared_product-gallery__zoom__zE4Rt","product-gallery__carousel-item":"shared_product-gallery__carousel-item__YOaGt","product-image--location--gallery":"shared_product-image--location--gallery__mX462","product-image__img":"shared_product-image__img__7FiK4","owl-carousel":"shared_owl-carousel__DZ_qV","owl-item":"shared_owl-item__1Ipyt","product-gallery__carousel-item--active":"shared_product-gallery__carousel-item--active__Y6uRZ","small-img-car_fms":"shared_small-img-car_fms__trqT1","product-small-img":"shared_product-small-img__19vI8","currency_value":"shared_currency_value__5IPjM","block-header":"shared_block-header__Y47R6","block-header__title":"shared_block-header__title__fNPSo","block-header__divider":"shared_block-header__divider__z_Ltc","block-header__groups-list":"shared_block-header__groups-list__Lcx3T","block-header__title__custom":"shared_block-header__title__custom__sD_wp","title-line-fms":"shared_title-line-fms__G_D1_","title-name-fms":"shared_title-name-fms__dTBlZ","block-header__group":"shared_block-header__group__wwwXx","block-header__group--active":"shared_block-header__group--active__Fl3KN","block-header__arrows-list":"shared_block-header__arrows-list__Acux7","block-header__arrow":"shared_block-header__arrow__IeFTb","block-header__arrow--left":"shared_block-header__arrow--left__UKyJW","block-header__arrow--right":"shared_block-header__arrow--right__KMu9G","breadcrumb":"shared_breadcrumb___jX19","minus_hide":"shared_minus_hide__G0BFC","input-number__input":"shared_input-number__input__pZxDP","input-number__sub":"shared_input-number__sub__8I6_b","input-number__add":"shared_input-number__add__0lk8a","form-control-sm":"shared_form-control-sm__fiyvR","product__quantity":"shared_product__quantity__j3dv_","cart-quantity-responsive":"shared_cart-quantity-responsive__5_4kx","page-header":"shared_page-header__36R5E","breadcrumb-item":"shared_breadcrumb-item__0qre7","breadcrumb-item-active":"shared_breadcrumb-item-active__V3KYS","page-header__breadcrumb":"shared_page-header__breadcrumb__i_Z7a","page-header__title":"shared_page-header__title__JaRFr","breadcrumb-arrow":"shared_breadcrumb-arrow__uQK9o","page-header__container":"shared_page-header__container__mEt_Q","pagination":"shared_pagination__bdXo7","sr-only":"shared_sr-only__9FqOD","page-link":"shared_page-link__CMUmq","page-link--with-arrow":"shared_page-link--with-arrow__c1IUc","page-link__arrow":"shared_page-link__arrow__mULrQ","page-link__arrow--left":"shared_page-link__arrow--left___61oN","page-link__arrow--right":"shared_page-link__arrow--right__k9sB2","page-item":"shared_page-item__dpA_F","page-item-disabled":"shared_page-item-disabled__DERIG","page-item-active":"shared_page-item-active__MPK7e","bottomNavigation-wrapper":"shared_bottomNavigation-wrapper__qch5s","indicatpr_area":"shared_indicatpr_area__8uOGn","bottom-nav-item--title":"shared_bottom-nav-item--title__vcuz0","bottom-nav-item--title-active":"shared_bottom-nav-item--title-active__XLHhd","local-item":"shared_local-item__lM6aT","local-item-active":"shared_local-item-active__SLCm2","active":"shared_active__9Ifpg","bottom-nav-item":"shared_bottom-nav-item__O_XHs","bottom-nav":"shared_bottom-nav__H2kJw","indicator__value":"shared_indicator__value__WOLbt","indicator":"shared_indicator__H_FQK","false":"shared_false___CPLZ","indicator__area":"shared_indicator__area__th4gv","mob_area":"shared_mob_area___TbbM","block-posts":"shared_block-posts___KdlJ","slick-slide":"shared_slick-slide__A6TQC","post-card":"shared_post-card__iG54_","block-posts--layout--list-sm":"shared_block-posts--layout--list-sm__U1MbP","post-card__image":"shared_post-card__image__7N_gj","post-card__name":"shared_post-card__name__mtEZ3","post-card__date":"shared_post-card__date__Vl_uC","post-card__category":"shared_post-card__category__tfnxa","post-card__content":"shared_post-card__content__WkHA7","post-card__read-more":"shared_post-card__read-more__8ZXB_","post-card__info":"shared_post-card__info__hGWgj","block-posts--layout--grid-nl":"shared_block-posts--layout--grid-nl__A6c3z","post-card__read-data":"shared_post-card__read-data__D4d0W","post-card--layout--related":"shared_post-card--layout--related__XefJD","post-card--layout--grid":"shared_post-card--layout--grid__e3_ld","post-card--size--lg":"shared_post-card--size--lg__x_1XA","post-card--layout--list":"shared_post-card--layout--list__wvqDN","post-card--size--nl":"shared_post-card--size--nl__AJ2H2","post-card--size--sm":"shared_post-card--size--sm__6Zwvl","social-links__list":"shared_social-links__list__dfW3w","social-links__item":"shared_social-links__item__7uXma","social-links__link":"shared_social-links__link__b_S9g","social-links--shape--circle":"shared_social-links--shape--circle__YFFEi","social-links--shape--rounded":"shared_social-links--shape--rounded__TT0YX","social-links__link--type--facebook":"shared_social-links__link--type--facebook__G719K","social-links__link--type--twitter":"shared_social-links__link--type--twitter__7ulYd","social-links__link--type--youtube":"shared_social-links__link--type--youtube__FWKHG","social-links__link--type--instagram":"shared_social-links__link--type--instagram___32Vy","social-links__link--type--rss":"shared_social-links__link--type--rss___vbZg","wishlist-circle":"shared_wishlist-circle__IHvkp","wishlist-icon-wrapper":"shared_wishlist-icon-wrapper__pW_9v","wishlist-circle-clicked":"shared_wishlist-circle-clicked__ZBHpI","inner-wishlist":"shared_inner-wishlist__S07T4","product-card__prices":"shared_product-card__prices__OXbim","uPsell-title":"shared_uPsell-title__TIb25","upsell_body":"shared_upsell_body__5qzyA","product__content":"shared_product__content__zHVz_","product__info":"shared_product__info__2JUdC","short_description_block":"shared_short_description_block__hIkfU","product-inner-description-title":"shared_product-inner-description-title__h9vAb","product__meta":"shared_product__meta__EwL40","product__sidebar":"shared_product__sidebar__O9bRJ","product__options":"shared_product__options__2X85W","product__actions":"shared_product__actions__dAK_0","no-thanks":"shared_no-thanks__G__wn","btn":"shared_btn__2IzVc","btn-orange":"shared_btn-orange__zc5e3","rounded-pills":"shared_rounded-pills__Z7qlr","product__name":"shared_product__name__QUTXW","ups-product__info":"shared_ups-product__info__W_YrR","item_overlay":"shared_item_overlay__qz1Am","product-card__image":"shared_product-card__image__IroED","cross__prods":"shared_cross__prods__xJAFI","input-number":"shared_input-number__mS_oj","product-image__default-fms":"shared_product-image__default-fms__0xjYL","product__actions-item--addToCart":"shared_product__actions-item--addToCart__dHUJi"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3061,7838,6033,3997,9774,2888,179], function() { return __webpack_exec__(27627); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);